import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { GoToTop, MarkerType, Toolbar, useGoToTop } from '~/app/components'
import HostInformation from '../../common/HostInformation'
import CancelPolicy from '../../common/CancelPolicy'
import conf from '~/app/conf'
import ClipboardJS from 'clipboard'
import QueryString from 'qs'
import useToolbarScroll from '~/app/components/common/Toolbar/useToolbarScroll'
import { CategoryOrderIdContainer } from '~/app/components/order-list/details/OrderDetailStyle'
import { Toast, ToastHandler } from '@yanolja-rnd/ya-com-toast'
import { Layout, ContentContainer, Content } from '~/app/components/layout-style'

/**
 * TrainInformation component
 * author: soojin.oh
 */

// type definitions
type TrainInformationProps = {
  onClickBack: () => void
  categoryOrderId: string
}

// styled components

// TrainInformation component
const TrainInformation: React.FC<TrainInformationProps> = function ({
  onClickBack,
  categoryOrderId,
}) {
  const toastRef = useRef<ToastHandler>()
  const triggerToast = useCallback(() => {
    toastRef.current?.addMessage({ message: '주소를 복사했어요', timeout: 3000 })
  }, [])

  const scrollTarget = useRef<HTMLDivElement>(null)
  const { isFabOpen, onClick } = useGoToTop(scrollTarget)
  const { hasShadow } = useToolbarScroll(scrollTarget)

  const cancelPolicyUrl = useMemo(() => {
    const queryString = QueryString.stringify({
      t: 'cancel',
      embed: true,
    })
    return `${conf.policy.url}/pf/train/cancel?${queryString}`
  }, [])

  useEffect(() => {
    const clipboard = new ClipboardJS('.link')
    clipboard.on('success', triggerToast)
  }, [])

  return (
    <Layout>
      <Toolbar
        title={'이용정보'}
        type={'close'}
        onClickBackButton={onClickBack}
        hasShadow={hasShadow}
      />
      <ContentContainer>
        <Content
          ref={scrollTarget}
          style={{ background: 'white', justifyContent: 'flex-start', padding: '1rem 0 6.4rem' }}
        >
          <CategoryOrderIdContainer>
            <div>기차 예약번호 {categoryOrderId}</div>
          </CategoryOrderIdContainer>
          <HostInformation
            id={'host'}
            hostName={'한국철도공사'}
            phone={'1544-7788'}
            address={'대전광역시 동구 중앙로 240'}
            coordinate={{ lat: 36.33195854970716, lng: 127.43621458211764 }}
            markerType={MarkerType.TRAIN}
          />
          <CancelPolicy id={'cancel-policy'} cancelPolicyUrl={cancelPolicyUrl} />
        </Content>
      </ContentContainer>
      <GoToTop onClick={onClick} isOpened={isFabOpen} />
      <Toast toastRef={toastRef} />
    </Layout>
  )
}

export default TrainInformation
